module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch4"
    }
  }, [_c('div', {
    staticClass: "chapterHeadA"
  }, [_c('p', {
    staticClass: "rightImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "images/ch4.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("I")]), _vm._v(" am sleepy, Simon’s baby! Sleepy! But it is not the right time to be sleepy. Not right! The wrong time …”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know it, Uncle,” I whispered. He thrashed once in the little cot he preferred to a bed, threatening to knock the empty rose-striped teacup from the table. “But remember what I told you, that when you wake up, you will have done just as Marianna said to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The usually bright, inquisitive eyes locked on to mine, searching my face for understanding. They were becoming dull and unfocused. “We should … always … do … always … remember what … Marianna … says. My little niece … knows. …”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("I gave him a Judas-like smile and sat down on the edge of his cot, to be near, though not so near as to make him uncomfortable. If he could only be unafraid in these last few moments, it was all I could ask. Mary stood a few feet away, a sick expression on her face, hands behind her, staring at the far wall of Uncle Tully’s bedchamber. I knew why she could not look. What we were doing went against every inclination of nature, like eating spoiled meat or slicing open one’s own skin. But I had promised myself long ago that I would do ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("anything for my uncle, that I would protect him at all costs, even if that protection was one he could never understand. I made no promise lightly.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uncle Tully pulled fitfully at the blankets, his movements losing force. “Marianna … said … Niece said … She …” The rest of his words were unintelligible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shhh, Uncle,” I soothed, my lies very gentle. “Marianna says it is time to sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uncle Tully’s eyelids fluttered shut, his breath coming slow. After a few moments, his hand fell limp on his chest, sliding down to rest at his side. The blankets did not move. We waited, holding our breath, listening to the quiet. Uncle Tulman lay peaceful, childlike, and very still on his little bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary moved first, dashing tears impatiently from her cheeks, and I stood, straightening my back, moving to the bedchamber door with the automatic precision of a piece of clockwork. Dr. Pruitt must have heard me coming because he was there when the door swung open, his forehead dotted with sweat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We are finished here,” I told him. “Please call the village committee together and say that I regret to inform them that Mr. Frederick Tulman is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shut the door behind Dr. Pruitt and locked it, turning back to gaze at Mary. She was already in motion, smoothing the blanket, arranging my uncle’s hair, liberties he would have never before allowed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I whispered into the silent room. “We have to move him, Mary. Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Two hours later I was in my bedchamber, comforting a nearly incoherent Mrs. Cooper. I had been dreading this moment, to the point of physical sickness, and now that the time was here it was infinitely worse than I’d imagined. I had been afraid I would be frosty and silent, an unfeeling statue in the face of the poor woman’s grief, and instead I cried just as hard as she did, guilt and a horrible, hot shame pouring out with the water from my eyes. Despite my pet name of “aunt,” Mrs. Cooper and I were of no relation, but she had lived a lifetime of loyalty to my uncle and for many months had been a kind of brusque and fussing mother to me. And we shared the same hurts, down to the length, shape, and maybe even depth of the wounds. We understood each other’s losses, and now I had been the one to give her another.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“’Tis too much,” she wheezed into her apron. “Too much. First Davy gone, and Lane leaving us, and now …”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("I’d already been to Davy’s grave that morning, in the little depression on top of the moor hill where Davy had always gone to play. Standing there beside the grassy mound, the wind lashing my back, I’d wished that the clocks’ hands could turn the wrong way and that none of it had ever happened. That Davy would come, small and silent, and lean against the standing stone, trying to imitate Lane’s lithe grace with a short body and a bunny in his lap. That we would all go rolling in the splendor of the ballroom. That Ben Aldridge had never laid eyes on Davy and that Lane had never blamed himself for failing to see how someone like Ben might have found such a child so easy to use and manipulate. That Davy had not been rescued from the workhouse only to come to Stranwyne and die. That Mr. Wickersham had never arrived on our doorstep, that this small grave ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("on the moor hill — and the lack of one for Ben — might never have compelled Lane to leave in the first place. That Ben Aldridge had remained unborn. If any of that had been so, then the awful deeds of today would have never been necessary.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs. Cooper was still crying, dabbing her eyes with an apron end. I gathered up the shreds of my courage. This would not do. I knew what was required of me. But still I could not speak. I put my gaze on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will you go with me, then?” she said. “Shall we go and be seeing Mr. Tully together?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another dagger of guilt went stabbing through my chest. We had gone together to see Davy’s body when it was found, the first of our common hurts. But that could not be. Not this time. I straightened my back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t wish to see my uncle, Aunt Bit.” I let the words sink in as she stared, shock actually stopping her tears. “I don’t wish for anyone to see him. He … does not look well. And I will not have him remembered that way. I will not.” I lifted my chin. “I won’t have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs. Cooper’s astonishment gave way to a frown. “But …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t have it,” I repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, Katie, pet,” she said, “who’s to do the laying out, and —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mary has already done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mrs. Cooper sat back in her chair, her jaw unhinged.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("“There will be a quiet burial tomorrow, with no fuss. Uncle Tully … he would not have wished for people or a commotion. You can see that, can’t you?” Pooled tears went rolling down my cheeks; I could not help or heed them. “And, Aunt Bit, I have made another ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("decision. I … I am leaving Stranwyne Keep. Immediately. And I expect that I shall be away … a longish time.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sat perfectly still. I stared down at my two hands, firmly clasped on the black silk of my mourning dress. “Of course, you shall be in charge of the house. I could trust no one else, and the kitchen is yours, as always. But the rest of the house is to be shut up. Until needed again.” I reached out to put a hand on hers. “This will always be your home. That does not change.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She removed her hand carefully from beneath mine. “But, Miss,” she said slowly. I bled internally that I was no longer her “Katie.” “Where will you be going?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I put my hand back in my lap. “I have decided to spend some time in Paris. My grandmother had a house there. Mr. Babcock will act as steward for the estate, as he once did, and will help to … arrange things.” I swallowed, my brief spurt of courage draining away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Paris?” she repeated. The ensuing pause was so long I was wondering if I should have clarified the city’s location in France when Mrs. Cooper suddenly said, “This is ’cause of him, ain’t it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("I looked up. The usual good-willed — or not-so-good-willed — foolishness that was so much a part of Mrs. Cooper’s features had been replaced with a flash of sharp penetration. She had no idea that Lane had gone to Paris, or why he had left Stranwyne in the first place. Stoicism not being one of Mrs. Cooper’s many good qualities, I had taken my cue from Lane’s secrecy and told her nothing about clandestine assignments from the British government, or the letter informing us of Lane’s death. But Aunt Bit had perceived what I was trying to hide, or at least part of it, and she was entirely right. I ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("was marching straight into the hornet’s nest of Paris for no other reason than to find Lane Moreau. And I would find him and throw Mr. Wickersham’s lies right back into his mustached face. Mrs. Cooper must have seen something of these thoughts in my expression because her eyebrows went up.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When that boy is coming back, there will be a murder done,” she pronounced, her tears beginning anew.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I could only believe that it hadn’t been done already.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The coffin is made, Miss, and Matthew is digging the grave, though I never knew a body to go so slow about a thing. I swear he —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did the boxes go this afternoon, Mary? They need to be at the house in Paris when we arrive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Miss, two wagonloads. And didn’t young Tom fuss about loading them, too? And he says there was a man up on the hill, Miss, away by the tunnel, watching the boxes go in —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you get the striped cups?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course I was getting them! What do you take me for, Miss? I swear the last —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here, Mary,” I said, shoving a wad of dark cloth quickly into her hands. “Press the lace on my black veil, would you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("She went out the door, still muttering and shaking her head. I sank down onto a stool, head aching, looking at bits of torn paper and odd pins, the flotsam that was all that remained of my life in my grandmother’s room. Now only my steamer trunk was left, ready for filling. Mary dealt with the pain of parting in words, but I needed quiet to let my own feelings writhe and fester. I picked up the silver swan from my dressing table, the gift Lane had made for me, its ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("delicate wings uplifted. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“I can feel it trying to fly,”")]), _vm._v(" I had told him, gazing at the swan balanced on my palm. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“You would like to fly, I think,”")]), _vm._v(" the low voice had replied. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“That is why it’s yours.”")]), _vm._v(" Now I did not wish to fly. I wanted nothing more than to stay at home.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The heavy knot in my middle pulled painfully tight, the silver swan warming to the heat of my hand. There were twenty-three hours until Mr. Wickersham came.")])])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4be111f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545578011_ch004.vue
// module id = 78
// module chunks = 0